class SafeUtils {

  get(obj: any = null, props: string[] = []): any {
    return props.reduce( (currObj, prop) => currObj && currObj[prop] ? currObj[prop] : null, obj );
  }

}

export default new SafeUtils();
